'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
import { withLocaleHref, type Locale } from '@/i18n/config';

export type NavigationDictionary = {
  Navigation: Record<string, string>;
};

export const Links = ({
  dictionary,
}: {
  dictionary: NavigationDictionary | { Navigation?: Record<string, string> };
}) => {
  const pathname = usePathname();
  const currentLocale = (pathname.split('/')[1] || 'en') as Locale;
  const { data: session } = useSession();

  const navigation = dictionary.Navigation || {};

  // Get feature flags from session, defaulting to true for backward compatibility
  const enableExpenses = session?.user?.enableExpenses ?? true;
  const enableProducts = session?.user?.enableProducts ?? true;

  return (
    <div className="gap-2 hidden md:flex">
      <Link
        href={withLocaleHref('/dashboard', currentLocale)}
        className="text-sm font-medium text-gray-900 hover:bg-accent px-3 py-2 rounded-sm dark:text-gray-400 dark:hover:text-white"
      >
        {navigation.dashboard}
      </Link>

      <Link
        href={withLocaleHref('/invoices', currentLocale)}
        className="text-sm font-medium text-gray-900 hover:bg-accent px-3 py-2 rounded-sm dark:text-gray-400 dark:hover:text-white"
      >
        {navigation.invoices}
      </Link>

      <Link
        href={withLocaleHref('/clients', currentLocale)}
        className="text-sm font-medium text-gray-900 hover:bg-accent px-3 py-2 rounded-sm dark:text-gray-400 dark:hover:text-white"
      >
        {navigation.clients}
      </Link>

      {enableProducts && (
        <Link
          href={withLocaleHref('/products', currentLocale)}
          className="text-sm font-medium text-gray-900 hover:bg-accent px-3 py-2 rounded-sm dark:text-gray-400 dark:hover:text-white"
        >
          {navigation.products}
        </Link>
      )}

      {enableExpenses && (
        <Link
          href={withLocaleHref('/expenses', currentLocale)}
          className="text-sm font-medium text-gray-900 hover:bg-accent px-3 py-2 rounded-sm dark:text-gray-400 dark:hover:text-white"
        >
          {navigation.expenses}
        </Link>
      )}

      <Link
        href={withLocaleHref('/support', currentLocale)}
        className="text-sm font-medium text-gray-900 hover:bg-accent px-3 py-2 rounded-sm dark:text-gray-400 dark:hover:text-white"
      >
        {navigation.support}
      </Link>
    </div>
  );
};
